import { BaseSectionProps } from "../types/landingSections";

const HeroSection: React.FC<BaseSectionProps> = ({ section }) => {
  const title = section?.props?.title ?? "";
  const description = section?.props?.subtitle ?? "";
  const items = section?.props?.items ?? [];

  /*   const styles = data?.theme?.globalStyles; */

  return (
    <section className="relative py-6 px-6">
      <div className="max-w-6xl mx-auto text-center">
        {/* TAG */}
        <div
          className="inline-flex px-4 py-2 rounded-full border text-sm mb-6"
          style={{
            color: "var(--accent-color)",
            borderColor: "var(--accent-color)",
            backgroundColor:
              "color-mix(in srgb, var(--accent-color) 20%, transparent)",
            fontFamily: "var(--font-family)",
          }}
        >
          Servicio profesional
        </div>

        {/* TÍTULO */}
        <h1
          className="font-bold leading-tight text-4xl"
          style={{
            color: "var(--h1-color)",
            fontFamily: "var(--font-family)",
          }}
        >
          {title}
        </h1>

        {/* DESCRIPCIÓN */}
        <p
          className="mt-6 max-w-3xl mx-auto"
          style={{
            color: "var(--text-color)",
            fontFamily: "var(--font-family)",
          }}
        >
          {description}
        </p>

        {items.length > 0 && (
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
            {items.map((item: any, index: number) => (
              <div
                key={index}
                className="p-6 rounded-2xl backdrop-blur border shadow-sm shadow-cyan-300"
                style={{
                  borderColor: "var(--accent-color)",
                }}
              >
                <h3
                  style={{
                    color: "var(--h3-color)",
                    fontFamily: "var(--font-family)",
                  }}
                >
                  {item.titulo}
                </h3>

                <p
                  className="mt-2"
                  style={{
                    color: "var(--text-color)",
                    fontFamily: "var(--font-family)",
                  }}
                >
                  {item.descripcion}
                </p>
              </div>
            ))}
          </div>
        )}

        {items.length === 0 && (
          <div
            className="mt-10"
            style={{
              color: "var(--text-color)",
              opacity: 0.5,
              fontFamily: "var(--font-family)",
            }}
          >
            No hay servicios disponibles
          </div>
        )}
      </div>
    </section>
  );
};

export default HeroSection;
